// extracted by mini-css-extract-plugin
export default {"notification":"Notification-notification-UPK7V Card-card-aoesq","name":"Notification-name-vjjgY","enabled":"Notification-enabled-rQjVY"};